import NotificationsIcon from '@material-ui/icons/Notifications';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';

import { useConnectWithNotifications } from '../../../hooks/use-connect-with-notifications';
import styles from '../styles.module.css';

interface Props {
  nftsOwnedCount: number | undefined;
  isOpen: boolean;
}

export const NftButton = ({ nftsOwnedCount, isOpen }: Props) => {
  const { address } = useAccount();
  const { openNotificationsModal } = useConnectWithNotifications();

  const isCurrentPage = location.pathname.startsWith(
    '/platform/marketplace/owned',
  );

  const linkCn = isCurrentPage ? styles.nftButtonSelected : styles.nftButton;

  return (
    <div className="mt-4 mb-2 flex gap-2 justify-center items-center">
      {isOpen ? (
        <div
          tabIndex={0}
          role="button"
          onClick={() => openNotificationsModal(address ?? '', true)}
          onKeyDown={() => openNotificationsModal(address ?? '', true)}
          className="flex justify-center pointer"
        >
          <NotificationsIcon style={{ fontSize: 24 }} />
        </div>
      ) : null}
      <Link to="/platform/marketplace/owned?from=sidebar" className={linkCn}>
        {isOpen ? `${nftsOwnedCount} Items owned` : 'Digital Collectibles'}
      </Link>
    </div>
  );
};
